import { createSlice } from '@reduxjs/toolkit';
import  * as TYPES  from '../../types';

export const basicDrawerSlice = createSlice({
    name: 'locales',
    initialState: {
        visible: false,
        otherVisible: false,
        chooseName: 'domesticTitle',
        telModelVisible: false,
        options: {
            type: '',
            doTour: '',
            index: 0,
            status: 0,
        },
        otherOptions: {
            status: 0,
        },
    },
    reducers: {
        basicDrawerEvent: (state, action) => {
            switch(action.payload.visible){
                case TYPES.DRAWERSHOW:
                    state.visible = true;
                    if(state.options){
                        state.options = {
                            ...state.options,
                            ...action.payload.options
                        }
                    }
                    break;
                case TYPES.DRAWERCLOSE:
                    state.visible = false;
                    if(state.options){
                        state.options = {
                            ...state.options,
                            ...action.payload.options
                        }
                    }
                    break;
                default:
                    state.visible = false;
                    if(state.options){
                        state.options = {
                            ...state.options,
                            ...action.payload.options
                        }
                    }
            }
        },
        basicDrawerClose: (state) => {
            state.chooseName = 'domesticTitle';
            state.options = {
                ...state,
                type: '',
                doTour: '',
                status: 0,
            };
           
        },
        basicOtherModelrClose: (state) => {
            state.chooseName = 'domesticTitle';
            state.otherOptions = {
                status: 0,
            }
        },
        basicOtherModelrEvent: (state, action) => {
            switch(action.payload.otherVisible){
                case TYPES.OTHERDRAWERSHOW:
                    state.otherVisible = true;
                    if(state.otherOptions){
                        state.otherOptions = {
                            ...state.otherOptions,
                            ...action.payload.otherOptions
                        }
                    }
                    break;
                case TYPES.OTHERDRAWERCLOSE:
                    state.otherVisible = false;
                    if(state.otherOptions){
                        state.otherOptions = {
                            ...state.otherOptions,
                            ...action.payload.otherOptions
                        }
                    }
                    break;
                default:
                    state.otherVisible = false;
                    if(state.otherOptions){
                        state.otherOptions = {
                            ...state.otherOptions,
                            ...action.payload.otherOptions
                        }
                    }
            }
        },
        telModelDventShow: (state) => {
            state.telModelVisible = true;
        },
        telModelDventHidden: (state) => {
            state.telModelVisible = false;
        }
    }
});